import React from "react"
import styled from "styled-components"
import { Formik } from "formik"
import * as Yup from "yup"
import { toast } from "react-toastify"

import { useIntl, FormattedMessage } from "react-intl"
import * as spacings from "styles/spacing"
import { red } from "styles/colors"
import Button from "components/Button"
import Input from "components/Input"
import Toast from "components/Toast"
import AppleLogoSrc from "images/apple-logo.png"
import { Link, useStaticQuery, graphql } from "gatsby"
import { mediaDown } from "styles/media"

const ButtonContainer = styled.div`
`

const Send = styled.div`
  margin-top: 8px;
  padding: 0 ${spacings.large};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: white;

  ${mediaDown.small`
    margin-top: 10px;
  `}
`
const Logo = styled.div`
  position: relative;
  top: -4px;
  margin: 0 7px 0px 0;
  float: left;
  img {
    width: 17px;
  }
`

const DownloadButton = () => {
  const intl = useIntl()
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            appstoreUrl
          }
        }
      }
    `
  )
  
  return (
    <ButtonContainer>
        <Button>
        <Link href={site.siteMetadata.appstoreUrl} target="_blank">
            <Send>
                <Logo><img src={AppleLogoSrc} /></Logo>                
                {intl.formatMessage({id: "home.download"})}
            </Send>
            </Link>
        </Button>
    </ButtonContainer>
  )
}

export default DownloadButton
